import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import MetaData from "@/utils/common/MetaData.ts";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";
import CapabilityType from "@/utils/constants/CapabilityType.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import CrossTableBlock = namaTypes.CrossTableBlock;
import EditScreenActionsBlock = namaTypes.EditScreenActionsBlock;
import EditScreenBlock = namaTypes.EditScreenBlock;
import EditScreenDashBoard = namaTypes.EditScreenDashBoard;
import EditScreenEmbeddedEdit = namaTypes.EditScreenEmbeddedEdit;
import EditScreenGrid = namaTypes.EditScreenGrid;
import EditScreenGroup = namaTypes.EditScreenGroup;
import EditScreenList = namaTypes.EditScreenList;
import EditScreenReport = namaTypes.EditScreenReport;

export default class BlockUtils {
  static qExpansionDuration = 300;
  static isValidBlockForAttach(presenter: EditPresenter, block: Block): boolean {
    const errorStore = useErrorsStore()
    if (!block.fieldId)
      return true;
    let fieldId = block.fieldId;
    if (!SecurityUtils.userCanView(presenter?.entityType!, fieldId, presenter?.calcEditModeApplicability()))
      return false;
    if (this.blockIsEditScreenGrid(block)) {
      let gridMetadata = MetaData.findFieldMetadata(fieldId, presenter.metadata!);
      if (!gridMetadata) {
        errorStore.pushErrorStr("It seems some one added a grid with the id " + fieldId + " but it does not exist.")
        return false
      }
      if (!SecurityUtils.userCanFeature(gridMetadata.relatedToFeature)) {
        return false;
      }
    }
    if (this.blockIsEditScreenList(block)) {
      if (!SecurityUtils.userCanAll(block.listViewEntityType, [CapabilityType.ListView]))
        return false;
    }
    if (ObjectChecker.isAnyEqualToFirst(block['namaClassTypeId'], 'EditScreenBlock', 'EditScreenActionsBlock')) {
      if (presenter.isQuickCreator() && !block.showInQuickCreate)
        return false;
    }
    return true;
  }

  static blockIsEditScreenGroup(block: Block): block is EditScreenGroup {
    return "editScreenGroup" in block && !!block.editScreenGroup;
  }

  static blockIsEditScreenGrid(block: Block): block is EditScreenGrid {
    return "editScreenGrid" in block && !!block.editScreenGrid;
  }

  static blockIsEditScreenActionsBlock(block: Block): block is EditScreenActionsBlock {
    return "editScreenActionsBlock" in block && !!block.editScreenActionsBlock;
  }

  private static blockIsEditScreenList(block: Block): block is EditScreenList {
    return "editScreenList" in block && !!block.editScreenList;
  }
}

 export type Block =
  (CrossTableBlock | EditScreenActionsBlock | EditScreenBlock | EditScreenDashBoard | EditScreenEmbeddedEdit | EditScreenGrid | EditScreenGroup | EditScreenList | EditScreenReport)
